import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_Value, valueId_IND, valueID_PosNeg, valueID_YesNo, valueType_EnumElement, valueType_Enumerated, valueType_Range, valueType_StandardRange, valueType_SubEnumerated, valueType_SubRange, valueType_SubTime, valueType_Time, valueType_TimeRange, valueType_Tuple } from '@app/hcs-shared';
import { flatArray } from '@nu-art/ts-common';
import { resolveValueDisplay } from '@app/hcs-shared';
import { ModuleFE_Variable } from '../variable/ModuleFE_Variable.js';
const passingTypes = [valueType_SubRange, valueType_EnumElement, valueType_TimeRange];
export const dispatch_onValueChanged = new ThunderDispatcherV3('__onValueUpdated');
export class ModuleFE_Value_Class extends ModuleFE_BaseApi {
    __searchFilterMapper = (item) => {
        if (!['enum-element', 'sub-range'].includes(item.type))
            return [];
        return [resolveValueDisplay(item), item._id];
    };
    __searchGroups = (items, filter) => {
        const validValues = items.filter(value => ['enum-element', 'sub-range'].includes(value.type));
        return [{
                group: this.dbDef.entityName,
                results: validValues.map(value => ({ _id: value._id, uiLabel: resolveValueDisplay(value) }))
            }];
    };
    _v1;
    uiValues = undefined;
    values = undefined;
    constructor() {
        super(DBDef_Value, dispatch_onValueChanged);
        this._v1 = {};
        // @ts-ignore
        this[this.defaultDispatcher.method] = async () => {
            this.values = this.cache.all();
        };
    }
    getValues() {
        if (!this.values)
            this.values = this.cache.all();
        return this.values;
    }
    async getUIValues() {
        if (!this.uiValues)
            this.uiValues = await this.toUIValues(this.cache.all());
        return this.uiValues;
    }
    toUIValues(values) {
        return values.map(value => {
            return {
                _id: value._id,
                _v: value._v,
                __created: value.__created,
                __updated: value.__created,
                label: value.label,
                type: value.type,
            };
        });
    }
    getRelatedValues(variable) {
        const dbValues = this.cache.all();
        const compoundValue = dbValues.find(item => item._id === variable.valueId);
        if (!compoundValue || compoundValue.type === valueType_StandardRange)
            return undefined;
        let values = [];
        if (compoundValue.type === valueType_Time)
            values = compoundValue.data.timeRanges.map(valueId => dbValues.find(item => item._id === valueId));
        else
            values = compoundValue.data[compoundValue.type === valueType_Range
                ? 'subsets'
                : 'scope'].map(valueId => dbValues.find(item => item._id === valueId));
        while (!values.every(item => passingTypes.includes(item.type))) {
            values = flatArray(values.map(value => {
                if (passingTypes.includes(value.type))
                    return value;
                return value.data[compoundValue.type === valueType_Range
                    ? 'subsets'
                    : 'scope'].map(valueId => dbValues.find(item => item._id === valueId));
            }));
        }
        let variableType = 'normal';
        if (values.every(value => value.type === valueType_SubRange))
            variableType = 'ranges';
        if (values.every(value => value.type === valueType_EnumElement))
            variableType = 'enums';
        if (values.every(value => value.type === valueType_TimeRange))
            variableType = 'time';
        return { variableType, values };
    }
    getValueLabel = (value) => {
        switch (value.type) {
            case valueType_EnumElement:
                return value.data.value;
            case valueType_Tuple: {
                switch (value._id) {
                    case valueID_YesNo:
                        return 'Tuple value Yes/No';
                    case valueID_PosNeg:
                        return 'Tuple value Pos/Neg';
                    case valueId_IND:
                        return 'Tuple value IND';
                    default:
                        return 'Unknown Tuple Value';
                }
            }
            case valueType_Time:
            case valueType_Enumerated:
            case valueType_StandardRange:
            case valueType_SubTime:
            case valueType_SubEnumerated:
            case valueType_Range: {
                const parentVariable = ModuleFE_Variable.cache.find(variable => variable.valueId === value._id);
                return parentVariable?.name ? `Value (${value.type}) under variable "${parentVariable.name}"` : `Unassigned value (${value.type})`;
            }
            case valueType_SubRange: {
                const parentValue = this.cache.find(v => v.type === valueType_Range
                    && v.data.subsets.includes(value._id));
                if (!parentValue)
                    return 'Unassigned sub range value';
                const parentVariable = ModuleFE_Variable.cache.find(v => v.valueId === parentValue._id);
                return `Sub range value under ${parentVariable ? `"the ${parentVariable.name}" variable` : 'unassigned range value'}`;
            }
            case valueType_TimeRange: {
                const parentValue = this.cache.find(v => v.type === valueType_Time
                    && v.data.timeRanges.includes(value._id));
                if (!parentValue)
                    return 'Unassigned time range value';
                const parentVariable = ModuleFE_Variable.cache.find(v => v.valueId === parentValue._id);
                return `Time range value under ${parentVariable ? `"the ${parentVariable.name}" variable` : 'unassigned time value'}`;
            }
        }
    };
}
export const ModuleFE_Value = new ModuleFE_Value_Class();
//# sourceMappingURL=ModuleFE_Value.js.map